import { CompanyCollectorIdentifierRepository } from '@domain/company-collector-identifier/repositories/company-collector-identifier.repository';
import { CompanyCollectorIdentifierRepositoryService } from '../repositories/company-collector-identifier.service';

export const CompanyCollectorIdentifierProvider = [
  {
    provide: CompanyCollectorIdentifierRepository,
    useClass: CompanyCollectorIdentifierRepositoryService,
  },
];
